export default __webpack_public_path__ + "static/media/Essex_Icons_Location 2.bbd69c30.svg";